import { Component, OnInit } from '@angular/core';
import { MsalService } from '../services/msal.service';
import { Globals } from '../services/globals';
import { EnergyDataService } from '../services/energy-data.service';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent
{
    // https://github.com/benbaran/adal-angular4-example/blob/master/src/app/toolbar/toolbar.component.ts

    constructor(private msalService: MsalService, private dataService: EnergyDataService, public globals: Globals) { }

    login() {
        this.msalService.login();
    }

    logout() {
        this.msalService.logout();
    }

    editProfile() {
        this.msalService.editProfile();
    }

    get authenticated(): boolean {
        return this.msalService.authenticated;
    }

    get username(): string {
        return this.msalService.username;
    }

    get hasMeteringPoints(): boolean {
        if (this.dataService.participantInfo) {
            return this.globals.demoData || this.dataService.participantInfo.hasMeteringPoints;
        } else {
            return this.globals.demoData;
        }
    }

    changeUnit() {
        this.globals.dataInEur = !this.globals.dataInEur;

        window.dispatchEvent(new CustomEvent("refreshData"));
    }

    changeDataSource() {
        this.globals.demoData = !this.globals.demoData;

        window.dispatchEvent(new CustomEvent("refreshData"));
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/_shared/navmenu/navmenu.component.ts